import React, {Component} from 'react';
import {Container, Row, Col, CardGroup, Card, CardBody, Button, Input, InputGroup, InputGroupAddon} from 'reactstrap';
import axios from 'axios';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: ''
    };
    this.handleLogin = this.handleLogin.bind(this);
  }
  
  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup className="mb-4">
                <Card className="p-4 shadow-lg">
                  <CardBody>
                    <h1>Login</h1>
                    <p className="text-muted">Sign In to your account</p>
                    <InputGroup className="mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="icon-user"></i>
                        </span>
                      </div>
                      <Input type="text" placeholder="Username"value={this.state.username}
                        onChange={(e) => this.setState({ username: e.target.value })}/>
                    </InputGroup>
                    <InputGroup className="mb-4">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="icon-lock"></i>
                        </span>
                      </div>
                      <Input type="password" placeholder="Password"
                      value={this.state.password}
                        onChange={(e) => this.setState({ password: e.target.value })}/>
                    </InputGroup>
                    <Row>
                      <Col xs="6">
                        <Button color="primary" className="px-4"  onClick={this.handleLogin}>Login</Button>
                      </Col>
                      <Col xs="6" className="text-right">
                        <Button color="link" className="px-0">Forgot password?</Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Card className="text-white bg-primary py-5 d-md-down-none shadow-lg" style={{ width: 44 + '%' }}>
                  <CardBody className="text-center">
                    <div>
                      <h2>Sign up</h2>
                      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
                        labore et dolore magna aliqua.</p>
                      <Button color="primary" className="mt-3" active>Register Now!</Button>
                    </div>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
    

  /*handleLogin(){
    console.log('Tombol udah di klik');
    
    axios.post('http://localhost/login-rect/php/Login.php', {
      username: this.state.username,
      password: this.state.password
    })
    .then(response => {
      const data = response.data;
      if (data.success) {
        alert(data.message);    
        //redirect ke dashboard
        window.location.hash = "#/full";
      } else {
        alert(data.message);
      }
    })
    .catch(error => {
      console.error('Login error:', error);
      alert('username atau password salah.');
    });
  };*/

  handleLogin() {
  console.log('Tombol udah di klik');

  const { username, password } = this.state;

  if (username === "pipi" && password === "123") {
    alert("Login berhasil!");
    // redirect ke dashboard
    window.location.hash = "#/full";
  } else {
    alert("Username atau password salah!");
  }
}


}

export default Login;
